import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, Field, isInvalid } from 'redux-form';

const ApiKeysCreate = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        invalid,
        pristine,
        submitting,
        translate,
    } = props;

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.api-keys.fields.name') }
                                name='name'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton
                                disabled={ pristine || submitting || invalid }
                                loading={ submitting }
                            />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

ApiKeysCreate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(ApiKeysCreate);



// WEBPACK FOOTER //
// ./src/pages/api-keys/create/ApiKeysCreate.js